import { Core } from "@faire/design-tokens";
import { Column, HorizontalLine } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";
import styled from "styled-components";

interface IProps {
  name?: string;
  hasPromoText?: boolean;
  showCategoryBrandStory: boolean;
  description?: string;
}
export const BrandStory: React.FC<IProps> = ({
  name,
  hasPromoText,
  showCategoryBrandStory,
  description,
}) => (
  <>
    <Spacer height="1x" />
    {showCategoryBrandStory && !!name ? (
      <Column align="flex-start" flex={1} style={{ position: "relative" }}>
        <HorizontalLine />
        <Spacer height="1x" />
        <BrandStoryWrapper $lines={hasPromoText ? 2 : 3}>
          {description}
        </BrandStoryWrapper>
      </Column>
    ) : null}
  </>
);

const BrandStoryWrapper = styled(Typography).attrs({
  forwardedAs: "p",
  color: Core.text.subdued,
  letterSpacing: 0.25,
})<{ $lines: number }>`
  &&& {
    position: relative;
    width: 100%;
    display: -webkit-box;
    overflow: hidden;
    max-height: ${(props) => `calc(22px * ${props.$lines})`};
    margin-bottom: 7.5%;
    -webkit-line-clamp: ${(props) => props.$lines};
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
`;
